<template>
  <RevCard class="p-24">
    <div class="mb-24 flex items-center justify-between">
      <div class="body-1 flex items-center gap-8">
        <IconRecommendation />
        {{ i18n(translations.title) }}
      </div>
    </div>

    <div class="space-y-12">
      <div class="heading-1">{{ i18n(translations.feedbackBlockTitle) }}</div>
      <div>{{ i18n(translations.feedbackBlockDescription) }}</div>

      <RevButton
        class="w-full md:w-auto"
        size="small"
        :to="{
          type: 'internal',
          name: ROUTE_NAMES.FEEDBACK,
          query: { formId: 'Xo0eL6Ti' },
        }"
        variant="primary"
      >
        {{ i18n(translations.feedbackBlockButton) }}
      </RevButton>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconRecommendation } from '@ds/icons/IconRecommendation'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Feedbacks.translations'

const i18n = useI18n()
</script>
